// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ipGq","textarea":"styles_textarea__1bC1w"};